import { NotificationTypes } from "state/types/UserTypes";
import { InitialState } from "state/InitialState";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import { UiActions } from "../UiActions";

// ----------------------------------------------------------------------

export const NotifsActions = {};

// THUNKS
// ----------------------------------------------------------------------

NotifsActions.dismiss = (notificationId) => {
  return (dispatch, getState) => {
    const state = getState();

    dispatch(NotifsActions.start());

    ExecuteRequest(
      GlamboxEndpoints.Person.readNotification,
      null,
      "POST",
      {
        Authorization: state.token.data.Authorization
      },
      {
        notificationId: notificationId
      },
      (response) => {
        let {
          result,
          statusCode
        } = response;

        dispatch(NotifsActions.pending(false));

        if (statusCode === 200) {
          dispatch(NotifsActions.success(true));

          dispatch(NotifsActions.read(result));
        } else {
          dispatch(
            NotifsActions.error(
              (result && result.message) 
                ? result.message 
                : "Erro"
            )
          );
        }
      }
    );
  };
};

NotifsActions.fetch = (page = 0, pageSize = 12) => {
  return (dispatch, getState) => {
    const state = getState();

    let requestData = {
      page: page || 0,
      pageSize: pageSize || 12
    };

    dispatch(NotifsActions.start());

    //let queueId = "Notifications-" + Date.now();
    //dispatch(UiActions.queue(queueId));

    ExecuteRequest(
      GlamboxEndpoints.Person.notification,
      requestData,
      "GET",
      {
        Authorization: state.token.data.Authorization
      },
      null,
      (response) => {
        let {
          result,
          statusCode
        } = response;

        dispatch(NotifsActions.pending(false));

        //dispatch(UiActions.dequeue(queueId));

        if (statusCode === 200) {
          dispatch(NotifsActions.success(true));

          dispatch(
            NotifsActions.set(
              result.content || []
            )
          );
        } else {
          dispatch(
            NotifsActions.error(
              (result && result.message) 
                ? result.message 
                : "Erro"
            )
          );
        }
      }
    );
  };
};

NotifsActions.start = () => {
  return (dispatch) => {
    dispatch(NotifsActions.pending(true));
    dispatch(NotifsActions.success(false));
    dispatch(NotifsActions.error(null));
  };
};

// ACTIONS PURAS
// ----------------------------------------------------------------------

NotifsActions.sync = () => ({
  notifs: {
    lastSync: Date.now()
  },
  type: NotificationTypes.sync
});

NotifsActions.set = (notifs) => ({
  notifs: {
    data: notifs,
    lastSync: Date.now()
  },
  type: NotificationTypes.set
});

NotifsActions.read = (notif) => ({
  notification: notif,
  type: NotificationTypes.read
});

NotifsActions.unset = () => ({
  notifs: InitialState.createSyncObject(),
  type: NotificationTypes.unset
});

NotifsActions.success = (success) => ({
  notifs: {
    success: (success === true)
  },
  type: NotificationTypes.success
});

NotifsActions.pending = (pending) => ({
  notifs: {
    pending: (pending === true)
  },
  type: NotificationTypes.pending
});

NotifsActions.error = (error) => ({
  notifs: {
    error
  },
  type: NotificationTypes.error
});
